/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_MembershipsInputs */

const en_admin_questionnaire_editor_memberships = /** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memberships`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const de_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const es_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const it_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/** @type {(inputs: Admin_Questionnaire_Editor_MembershipsInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_memberships = en_admin_questionnaire_editor_memberships;

/**
* | output |
* | --- |
* | "Memberships" |
*
* @param {Admin_Questionnaire_Editor_MembershipsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_memberships = /** @type {((inputs?: Admin_Questionnaire_Editor_MembershipsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_MembershipsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_memberships(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_memberships(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_memberships(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_memberships(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_memberships(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_memberships(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_memberships(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_memberships(inputs)
	return ro_admin_questionnaire_editor_memberships(inputs)
});
export { admin_questionnaire_editor_memberships as "admin.questionnaire_editor.memberships" }